<template>
  <v-text-field
          ref="textField"
          v-model="textValue"
          :label="labelText"
          :type="type"
          :outlined="!simple"
          :disabled="disabled"
          :rules="textFieldRules"
          :counter="showCounter"
          :suffix="suffix"
          @keypress.enter="onSubmit"
          @keypress="onKeyPress"
          @focusout="onFocusOut"
          :maxlength="max"
          :hide-details="simple"
          :autocomplete="autoComplete"
          :append-icon="icon"
          :prepend-inner-icon="prependInnerIcon"
          :placeholder="placeholder"
          :hint="hint"
          :persistent-hint="Boolean(hint)"
          :readonly="readonly"
          @click:append="onSubmit"
  ></v-text-field>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "TextField",
    props: {
      "value": [String, Number, null],
      "name": String,
      "type": String,
      "disabled": Boolean,
      "simple": Boolean,
      "required": Boolean,
      "min": Number,
      "max": Number,
      "rules": Array,
      "submit": Function,
      "icon": String,
      "prependInnerIcon": String,
      "placeholder": String,
      "suffix": String,
      "hint": String,
      "noCounter": Boolean,
      "readonly": Boolean,
    },
    computed: {
      textValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("input", value === "" ? null : value)
        }
      },
      textFieldRules () {
        return [
          value => {
            if (this.required)
              return !!value || this.error("required", [this.name]);
            return true;
          },
          value => {
            if (this.min)
              return (value && value.length >= this.min) || this.error("min", [this.min]);
            return true;
          }
        ].concat(this.rules || [])
      },
      labelText () {
        if ((!this.min && !this.max) || this.noCounter) {
          return this.name
        }
        if (this.min && this.max) {
          return this.label("nameWithMinAndMax", [this.name, this.min, this.max])
        }
        if (this.min) {
          return this.label("nameWithMin", [this.name, this.min])
        }
        return this.label("nameWithMax", [this.name, this.max])
      },
      showCounter () {
        return this.min != null
      },
      autoComplete () {
        return this.type === 'password' ? "new-password" : "off"
      }
    },
    methods: {
      onSubmit () {
        if (this.submit) {
          this.submit();
        }
        this.$emit("enter", this.value);
      },
      onKeyPress(event) {
        this.$emit("keypress", event)
      },
      onFocusOut() {
        this.$emit("focusout");
      }
    }
  }
</script>

<style scoped>

</style>
